import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=36bea66c&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36bea66c')) {
      api.createRecord('36bea66c', component.options)
    } else {
      api.reload('36bea66c', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=36bea66c&", function () {
      api.rerender('36bea66c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2AnmJhTc5nBgO/JS/imageCarousel.vue"
export default component.exports